import React from "react";

import Card from "~/account/Integrations/Card";
import { ReactComponent as SalesforceLogo } from "~/legacy-assets/images/logos/salesforce.svg";

import styles from "./Salesforce.module.css";

interface SalesforceProps {
	connection: {
		id?: string;
		email?: string;
		isConnected?: boolean;
	} | null;
	className?: string;
}

export function SalesforceCard(props: SalesforceProps) {
	return (
		<Card
			name="Salesforce"
			description="Sync your notes to Salesforce and view key Salesforce data within Fellow."
			connected={props.connection?.isConnected != null}
			logo={<SalesforceLogo style={{ width: "auto", height: "24px", color: "#00A1E0" }} />}
			className={props.className}
		>
			<div className={styles.cardContent}>
				{props.connection?.email && (
					<span>
						Connected as <a>{props.connection.email}</a>
					</span>
				)}
			</div>
		</Card>
	);
}
